import React, { useState, useEffect, useRef } from "react";
import { checkResult } from "@/common";
import { checkPhone } from "@/check";
import { useWatchState, setState } from "@/store";
import { BaseService } from "@/service";
import { Modal, Tabs, message, Form, Radio, Button, Icon, Row, Col, Card, Input, Popover } from "antd";
import "./style.less";
import button_close from './images/button_close.png';
import { ProjectScopeName } from "../projectRec/projectFunction"
const { confirm } = Modal;

function callback(key) {
    console.log(key);
}

const NAME = "projectTop";

const App = Form.create({ name: 'register' })((props) => {
    const add_date = parseInt(new Date().getTime() / 1000);
    const { getFieldDecorator } = props.form;
    const [loading, setLoading] = useState(false);
    const [[IS_REGION], [{ IS_LOGIN, info }]] = useWatchState(["IS_REGION", "user",]);
    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME]);
    const { show, hide, width = 1200, height = 943, callback, DetailId } = modalProps;
    const [data, setData] = useState([]);
    const [orgName, setOrgName] = useState('');
    const [personName, setPersonName] = useState('');
    const [winVisible, setWinVisible] = useState('true');
    const { TabPane } = Tabs;

    const getRecRecord = project_id => {
        BaseService.list({
            table: "thtt_project",
            where: {
                id: project_id,
                "thtt_project.is_delete": 0,
            },
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result[0];
            const orgRecId = res.data.result[0].orgRec_id;
            const personRecId = res.data.result[0].personRec_id;
            if ((orgRecId !== 'null') && (personRecId == 'null' || personRecId == '已选择推荐单位')) {
                BaseService.list({
                    table: "thtt_project_recommend",
                    where: {
                        id: orgRecId,
                        is_delete: 0,
                    },
                }).then(resRecOrg => {
                    if (!checkResult(resRecOrg)) return;
                    setOrgName(resRecOrg.data.result[0].org_name);
                })
            }
            else {
                BaseService.list({
                    table: "thtt_project_recommend",
                    where: {
                        id: personRecId,
                        is_delete: 0,
                    },
                }).then(resRecPerson => {
                    if (!checkResult(resRecPerson)) return;
                    setPersonName(resRecPerson.data.result[0].org_name);
                })
            }
            setData(data);
        })
    }

    useEffect(() => {
        if (DetailId) getRecRecord(DetailId)
    }, [DetailId])

    const handleSubmit1 = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                addContacts1(values);
            }
        });
    };

    const addContacts1 = vo => {
        setLoading(true);
        BaseService.add({
            table: "thtt_project_contacts",
            data: {
                ...vo,
                project_item_id: DetailId,
                project_contacts_type: 1,
                add_date: add_date,
                is_delete: 0
            }
        }).then(res => {
            setLoading(false);
            if (!checkResult(res)) return;
            message.success("您的提交已成功，我们会尽快与您联系！");
            hide();
        }, err => setLoading(false))
    }

    const handleSubmit2 = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                addContacts2(values);
            }
        });
    };

    const addContacts2 = vo => {
        setLoading(true);
        BaseService.add({
            table: "thtt_project_contacts",
            data: {
                ...vo,
                project_item_id: DetailId,
                project_contacts_type: 2,
                add_date: add_date,
                is_delete: 0
            }
        }).then(res => {
            setLoading(false);
            if (!checkResult(res)) return;
            message.success("您的提交已成功，我们会尽快与您联系！");
            hide();
        }, err => setLoading(false))
    }

    return (
        <Modal
            visible={show}
            width={width}
            height={height}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
            className="modal-windows"
            maskStyle={{ background: 'rgba(0,0,0,0.7)' }}
            bodyStyle={{ overflow: 'hidden', height: '100%' }}
        >
            <div style={{ height: 943 }}>
                <div className="modal_short" style={{ marginTop: "-10px" }}>
                    <ul>
                        <li style={{ marginLeft: 17 }}>百优项目名称：<span>{data.optimize_name}</span></li>
                        <li>项目领域：<span>{ProjectScopeName(data.scope)}</span></li>
                        <li>项目地区：<span>{data.org_province_name}</span></li><br />
                        <li className="listItem" style={{ marginLeft: "17px", width: "1000px" }}>项目申报名称：<span>{data.name}</span><span style={{ marginLeft: "50px" }}>申报单位：{data.org_name}</span></li>
                        <li className="listItem" style={{ marginLeft: "17px" }}>{(data.orgRec_id !== 'null') ? '项目推荐单位：' : '项目推荐个人：'}<span>{(data.orgRec_id !== 'null') ? orgName : personName}</span></li>
                    </ul>
                </div>
                <div className="modal_content" dangerouslySetInnerHTML={{ __html: data.optimize_profile }}></div>
                {/*<div className="modal_short" style={{ paddingTop: 70 }}>
                    <ul>
                        <li style={{ marginLeft: 17, cursor: "Pointer" }}>
                            <Popover placement="right" content={(<img src={"http://" + UPLOAD_SERVER_HOST + data["evaluate_file"]} width="706" height="1038" />)} trigger="click" ><span className="fontBlue"><Icon type="download" />《专委会推荐意见书》</span></Popover>
                        </li>
                        <li style={{ marginLeft: 50, cursor: "Pointer" }}>
                            <Popover placement="right" content={(<img src={"http://" + UPLOAD_SERVER_HOST + data["score_file"]} width="706" height="1038" />)} trigger="click" ><span className="fontBlue"><Icon type="download" />《专家评价打分表》</span></Popover>
                        </li>
                    </ul>
                </div>*/}
                <div className="modal_short" style={{ paddingTop: 100, marginLeft: 70 }}>
                    <ul>
                        <li style={{ marginRight: "510px" }}>
                            <Popover placement="topLeft"
                                content={(
                                    <div className="form_bg">
                                        <h2 style={{ color: "#fff", paddingLeft: 270, paddingTop: 0 }}>百优项目合作意向申请登记表</h2>
                                        <div className="card-container">
                                            <Form onSubmit={handleSubmit1}>
                                                <Tabs type="card" style={{ height: 200 }}>
                                                    <TabPane tab="资本合作" key="1">
                                                        <Row gutter={20} style={{ marginLeft: 20 }}>
                                                            <input name="cooperate_type" type="hidden" value={1} />
                                                            <Col className="Col5">
                                                                <Card title="项目股权投资" bordered={false}>
                                                                    {getFieldDecorator("equity_investment", {
                                                                        initialValue: data.equity_investment,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.equity_investment",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}

                                                                </Card>
                                                            </Col>
                                                            <Col className="Col5">
                                                                <Card title="项目金融信贷" bordered={false}>
                                                                    {getFieldDecorator("financial_credit", {
                                                                        initialValue: data.financial_credit,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.financial_credit",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col5">
                                                                <Card title="项目并购合作" bordered={false}>
                                                                    {getFieldDecorator("merger_acquisition", {
                                                                        initialValue: data.merger_acquisition,

                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.merger_acquisition",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col5">
                                                                <Card title="项目融资代理" bordered={false}>
                                                                    {getFieldDecorator("financing_agency", {
                                                                        initialValue: data.financing_agency,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.financing_agency",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col5">
                                                                <Card title="项目上市运作" bordered={false}>
                                                                    {getFieldDecorator("listing_operation", {
                                                                        initialValue: data.listing_operation,

                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.listing_operation",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    </TabPane>
                                                    <TabPane tab="技术合作" key="2">
                                                        <input name="cooperate_type" type="hidden" value={2} />
                                                        <Row gutter={20} style={{ marginLeft: 20 }}>
                                                            <Col className="Col4">
                                                                <Card title="技术专家顾问咨询" bordered={false}>
                                                                    {getFieldDecorator("consulting", {
                                                                        initialValue: data.consulting,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.consulting",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col4">
                                                                <Card title="技术中心合作共建" bordered={false}>
                                                                    {getFieldDecorator("joint_construction", {
                                                                        initialValue: data.joint_construction,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.joint_construction",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col4">
                                                                <Card title="技术项目合作研发" bordered={false}>
                                                                    {getFieldDecorator("research_development", {
                                                                        initialValue: data.research_development,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.research_development",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col4">
                                                                <Card title="技术成果转移交易" bordered={false}>
                                                                    {getFieldDecorator("transfer_transaction", {
                                                                        initialValue: data.transfer_transaction,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.transfer_transaction",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    </TabPane>
                                                    <TabPane tab="产业合作" key="3">
                                                        <input name="cooperate_type" type="hidden" value={3} />
                                                        <Row gutter={20} style={{ marginLeft: 20 }}>
                                                            <Col className="Col4">
                                                                <Card title="产业资源供给" bordered={false}>
                                                                    {getFieldDecorator("resource_supply", {
                                                                        initialValue: data.resource_supply,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.resource_supply",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col4">
                                                                <Card title="产业链条配套" bordered={false}>
                                                                    {getFieldDecorator("chain_matching", {
                                                                        initialValue: data.chain_matching,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.chain_matching",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col4">
                                                                <Card title="产业园区招商" bordered={false}>
                                                                    {getFieldDecorator("attract_investment", {
                                                                        initialValue: data.attract_investment,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.attract_investment",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col4">
                                                                <Card title="产业政策扶持" bordered={false}>
                                                                    {getFieldDecorator("policy_support", {
                                                                        initialValue: data.policy_support,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.policy_support",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    </TabPane>
                                                    <TabPane tab="市场合作" key="4">
                                                        <input name="cooperate_type" type="hidden" value={4} />
                                                        <Row gutter={20} style={{ marginLeft: 20 }}>
                                                            <Col className="Col4">
                                                                <Card title="市场战略规划设计" bordered={false}>
                                                                    {getFieldDecorator("plan_design", {
                                                                        initialValue: data.plan_design,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.plan_design",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col4">
                                                                <Card title="产品市场包装宣传" bordered={false}>
                                                                    {getFieldDecorator("packaging_promotion", {
                                                                        initialValue: data.packaging_promotion,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.packaging_promotion",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col4">
                                                                <Card title="应用场景拓展开发" bordered={false}>
                                                                    {getFieldDecorator("expand_development", {
                                                                        initialValue: data.expand_development,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.expand_development",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                            <Col className="Col4">
                                                                <Card title="产品销售渠道代理" bordered={false}>
                                                                    {getFieldDecorator("channel_agent", {
                                                                        initialValue: data.channel_agent,
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={(e) =>
                                                                                setState(
                                                                                    "modal." + NAME + ".vo.channel_agent",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio value={1}>
                                                                                是
                                                                            </Radio>
                                                                            <Radio value={2}>
                                                                                否
                                                                            </Radio>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    </TabPane>
                                                </Tabs>
                                                <div className="warp_bg_empty">
                                                    <Form.Item label="单位：" type="flex" style={{ width: 750, color: "#ffffff" }}>
                                                        {getFieldDecorator('contacts_org', {
                                                            initialValue: data.contacts_org,
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: '请输入您的单位名称！',
                                                                },
                                                            ],
                                                        })(<Input maxLength={200} placeholder="请输入您的单位名称" style={{ width: 650 }} />)}
                                                    </Form.Item>
                                                    <Row type="flex" style={{ width: 750 }}>
                                                        <Form.Item label="职务：" type="flex" style={{ width: 250, color: "#ffffff" }}>
                                                            {getFieldDecorator('contacts_position', {
                                                                initialValue: data.contacts_position,
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: '请输入您的职务！',
                                                                    },
                                                                ],
                                                            })(<Input maxLength={100} placeholder="请输入您的职务" style={{ width: 150 }} />)}
                                                        </Form.Item>
                                                        <Form.Item label="姓名：" type="flex" style={{ width: 250, color: "#ffffff" }}>
                                                            {getFieldDecorator('contacts_name', {
                                                                initialValue: data.contacts_name,
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: '请输入您的姓名！',
                                                                    },
                                                                ],
                                                            })(<Input maxLength={100} placeholder="请输入您的姓名" style={{ width: 150 }} />)}
                                                        </Form.Item>
                                                        <Form.Item label="电话：" type="flex" style={{ width: 250, color: "#ffffff" }}>
                                                            {getFieldDecorator('contacts_phone', {
                                                                initialValue: data.contacts_phone,
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: '请输入您的电话！',
                                                                    },
                                                                ],
                                                            })(<Input maxLength={20} placeholder="请输入您的电话" style={{ width: 150 }} />)}
                                                        </Form.Item>
                                                    </Row>
                                                    <li style={{ marginTop: 20, float: "left", type: "flex", marginLeft: 150 }}>
                                                        <Button loading={loading} type="default" onClick={hide} style={{ float: "left", type: "flex", width: 100, marginTop: "5px" }} shape="round">取消</Button>
                                                        <Button loading={loading} type="primary" style={{ width: 180, marginLeft: 80, marginTop: 7 }} shape="round" onClick={handleSubmit1}>确认合作提交</Button>
                                                    </li>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                )} trigger="click" >
                                <p className="btn_bg fontRed"><span style={{ paddingLeft: 120, paddingTop: 20 }}>非项目方</span><span style={{ paddingLeft: 80, paddingTop: 20 }}>项目合作服务申请</span></p>
                            </Popover>
                        </li>
                        <li style={{ marginRight: "-50px" }}> <Popover placement="topRight" content={(
                            <div className="form_bg">
                                <h2 style={{ color: "#fff", paddingLeft: 270, paddingTop: 30 }}>百优项目延伸服务申请登记表</h2>
                                <div className="card-container">
                                    <Form onSubmit={handleSubmit2}>
                                        <Tabs type="card" style={{ height: 200 }}>
                                            <TabPane tab="精准化供需对接推介活动" key="1">
                                                <Row gutter={20} style={{ marginLeft: 20 }}>
                                                    <Col className="Col3">
                                                        <Card title="定向推介活动" bordered={false}>
                                                            {getFieldDecorator("directional", {
                                                                initialValue: data.directional,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.directional",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col3">
                                                        <Card title="专项推介活动" bordered={false}>
                                                            {getFieldDecorator("special", {
                                                                initialValue: data.special,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.special",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col3">
                                                        <Card title="专题推介活动" bordered={false}>
                                                            {getFieldDecorator("special_subject", {
                                                                initialValue: data.special_subject,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.special_subject",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>

                                                </Row>
                                            </TabPane>
                                            <TabPane tab="专业化诊断评价策划业务" key="2">
                                                <Row gutter={20} style={{ marginLeft: 20 }}>
                                                    <Col className="Col4">
                                                        <Card title="项目过滤筛选" bordered={false}>
                                                            {getFieldDecorator("filter", {
                                                                initialValue: data.filter,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.filter",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col4">
                                                        <Card title="项目对接撮合" bordered={false}>
                                                            {getFieldDecorator("matchmaking", {
                                                                initialValue: data.matchmaking,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.matchmaking",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col4">
                                                        <Card title="项目策划促进" bordered={false}>
                                                            {getFieldDecorator("planning_promotion", {
                                                                initialValue: data.planning_promotion,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.planning_promotion",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col4">
                                                        <Card title="项目落地平台" bordered={false}>
                                                            {getFieldDecorator("landing_platform", {
                                                                initialValue: data.landing_platform,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.landing_platform",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tab="数字化云网智能服务平台" key="3">
                                                <Row gutter={20} style={{ marginLeft: 20 }}>
                                                    <Col style={{ width: 500 }}>
                                                        <Card title="数字化云网智能服务平台" bordered={false}>
                                                            {getFieldDecorator("digitized_cloud", {
                                                                initialValue: data.digitized_cloud,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.digitized_cloud",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tab="常态化共建科创实体机构" key="4">
                                                <Row gutter={20} style={{ marginLeft: 20 }}>
                                                    <Col className="Col3">
                                                        <Card title="地区合作机构" bordered={false}>
                                                            {getFieldDecorator("regional", {
                                                                initialValue: data.regional,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.regional",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col3">
                                                        <Card title="行业合作机构" bordered={false}>
                                                            {getFieldDecorator("industry", {
                                                                initialValue: data.industry,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.industry",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col3">
                                                        <Card title="国际合作机构" bordered={false}>
                                                            {getFieldDecorator("international", {
                                                                initialValue: data.international,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.international",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tab="生态化落地项目育成工场" key="5">
                                                <Row gutter={20} style={{ marginLeft: 20 }}>
                                                    <Col className="Col5">
                                                        <Card title="资本市场投资" bordered={false}>
                                                            {getFieldDecorator("capital_market", {
                                                                initialValue: data.capital_market,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.capital_market",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col5">
                                                        <Card title="产业园区招商" bordered={false}>
                                                            {getFieldDecorator("investment_promotion", {
                                                                initialValue: data.investment_promotion,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.investment_promotion",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col5">
                                                        <Card title="地区经济产业" bordered={false}>
                                                            {getFieldDecorator("economic_industry", {
                                                                initialValue: data.economic_industry,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.economic_industry",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col5">
                                                        <Card title="大型企业重大" bordered={false}>
                                                            {getFieldDecorator("large_enterprises", {
                                                                initialValue: data.large_enterprises,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.large_enterprises",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                    <Col className="Col5">
                                                        <Card title="中小企业跃升" bordered={false}>
                                                            {getFieldDecorator("medium_sized", {
                                                                initialValue: data.medium_sized,
                                                            })(
                                                                <Radio.Group
                                                                    onChange={(e) =>
                                                                        setState(
                                                                            "modal." + NAME + ".vo.medium_sized",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <Radio value={1}>
                                                                        是
                                                                    </Radio>
                                                                    <Radio value={2}>
                                                                        否
                                                                    </Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                        </Tabs>

                                        <div className="warp_bg_empty">
                                            <Form.Item label="单位：" type="flex" style={{ width: 750, color: "#ffffff" }}>
                                                {getFieldDecorator('contacts_org', {
                                                    initialValue: data.contacts_org,
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: '请输入您的单位名称！',
                                                        },
                                                    ],
                                                })(<Input maxLength={200} placeholder="请输入您的单位名称" style={{ width: 650 }} />)}
                                            </Form.Item>
                                            <Row type="flex" style={{ width: 750 }}>
                                                <Form.Item label="职务：" type="flex" style={{ width: 250, color: "#ffffff" }}>
                                                    {getFieldDecorator('contacts_position', {
                                                        initialValue: data.contacts_position,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: '请输入您的职务！',
                                                            },
                                                        ],
                                                    })(<Input maxLength={100} placeholder="请输入您的职务" style={{ width: 150 }} />)}
                                                </Form.Item>
                                                <Form.Item label="姓名：" type="flex" style={{ width: 250, color: "#ffffff" }}>
                                                    {getFieldDecorator('contacts_name', {
                                                        initialValue: data.contacts_name,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: '请输入您的姓名！',
                                                            },
                                                        ],
                                                    })(<Input maxLength={100} placeholder="请输入您的姓名" style={{ width: 150 }} />)}
                                                </Form.Item>
                                                <Form.Item label="电话：" type="flex" style={{ width: 250, color: "#ffffff" }}>
                                                    {getFieldDecorator('contacts_phone', {
                                                        initialValue: data.contacts_phone,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: '请输入您的电话！',
                                                            },
                                                        ],
                                                    })(<Input maxLength={20} placeholder="请输入您的电话" style={{ width: 150 }} />)}
                                                </Form.Item>
                                            </Row>
                                            <li style={{ marginTop: 20, float: "left", type: "flex", marginLeft: 150 }}>
                                                <Button loading={loading} type="default" onClick={hide} style={{ float: "left", type: "flex", width: 100, marginTop: "5px" }} shape="round">取消</Button>
                                                <Button loading={loading} type="primary" style={{ width: 180, marginLeft: 80, marginTop: 7 }} shape="round" onClick={handleSubmit2}>确认提交延伸服务申请</Button>
                                            </li>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        )} trigger="click" >
                            <p className="btn_bg fontRed" style={{ marginLeft: 660, marginTop: "-118px" }}><span style={{ paddingLeft: 125, paddingTop: 20 }}>项目方</span><span style={{ paddingLeft: 80, paddingTop: 20 }}>项目延伸服务申请</span></p>
                        </Popover></li>
                    </ul>
                </div>
                <div className="modal_short" style={{ paddingTop: 35, marginLeft: 563 }}>
                    <button onClick={hide}><img src={button_close} alt="关闭" /></button>
                </div>
            </div>
        </Modal>
    );
})
export default App;